import { render, staticRenderFns } from "./PeoplePulloutProfilePanel.vue?vue&type=template&id=5dc8de9d&scoped=true&"
import script from "./PeoplePulloutProfilePanel.vue?vue&type=script&lang=js&"
export * from "./PeoplePulloutProfilePanel.vue?vue&type=script&lang=js&"
import style0 from "./PeoplePulloutProfilePanel.vue?vue&type=style&index=0&id=5dc8de9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc8de9d",
  null
  
)

export default component.exports